import accountMutations from './account'
import walldashMutations from './walldash'
import dashboardMutations from './dashboard'
import commonMutations from './common'
import serviceGroupsMutations from './service-groups'
import analytics from './analytics'
import caseMutations from './case'
import caseServiceLogMutations from './case-service-log'
import devMutations from './dev'
import invoicesMutations from './invoices'
import contractorsMutation from './contractors'
import metadataMutations from './metadata'
import referencesMutations from './references'
import costCentersActions from './cost-centers'
import regionActions from './regions'
import fetchDPUrl from "./fetch-dp-url"

export default {
  ...accountMutations,
  ...walldashMutations,
  ...dashboardMutations,
  ...commonMutations,
  ...serviceGroupsMutations,
  ...analytics,
  ...caseMutations,
  ...caseServiceLogMutations,
  ...devMutations,
  ...invoicesMutations,
  ...contractorsMutation,
  ...metadataMutations,
  ...referencesMutations,
  ...costCentersActions,
  ...regionActions,
  ...fetchDPUrl
}



// WEBPACK FOOTER //
// ./src/store/mutations/index.js